import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { motion } from "framer-motion";
import { Toaster } from "sonner";
import { Nav } from "../components/site/Nav";
import { Footer } from "../components/site/Footer";
import { FloatingWhatsApp } from "../components/site/FloatingWhatsApp";
import { galleryImages } from "../data/site";
import { fadeUp } from "../lib/motion";
import { useLanguage } from "../lib/i18n";

export default function GalleryPage() {
  const { t } = useLanguage();

  useEffect(() => {
    document.title = "Gallery | Mediterranean Palate";
    window.scrollTo(0, 0);
    return () => { document.title = "Private Chef in Rutland & Stamford | Mediterranean Palate"; };
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="grain-overlay" />
      <Toaster theme="dark" position="bottom-right" />
      <Nav />
      <main data-testid="gallery-page">
        <section className="tiled relative pt-28 md:pt-32 pb-10 md:pb-12 min-h-screen bg-[--bg]">
          <div className="max-w-[1600px] mx-auto px-5 md:px-10">
            <motion.div variants={fadeUp} initial="hidden" animate="visible" className="max-w-3xl mb-14 bg-[--surface] border border-white/10 rounded-2xl p-8 md:p-12">
              <p className="font-mono uppercase tracking-[0.3em] text-[11px] text-[--gold] mb-6">{t("gallery.eyebrow")}</p>
              <h1 className="font-display font-light tracking-tight leading-[1.05] text-3xl sm:text-4xl md:text-5xl text-[--text]">
                {t("gallery.h2a")} <span className="italic text-[--gold]">{t("gallery.h2b")}</span>{t("gallery.h2c")}
              </h1>
            </motion.div>

            <div className="grid grid-cols-2 md:grid-cols-4 grid-flow-dense gap-4 md:gap-5">
              {galleryImages.map((g, i) => (
                <motion.div
                  key={i}
                  variants={fadeUp}
                  custom={i % 4}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, margin: "-40px" }}
                  className={`group relative overflow-hidden rounded-2xl border border-[--olive] ${i % 5 === 0 ? "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto" : "aspect-square"}`}
                >
                  <img src={g.src} alt={g.alt} className="photo-grade w-full h-full object-cover scale-100 group-hover:scale-105 transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)]" />
                  <div className="absolute inset-0 bg-[#2A331D]/20 mix-blend-soft-light pointer-events-none" />
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </ReactLenis>
  );
}
